<template>
  <div class="taxiContainner">
    <div class="news_title">
      行业监督信息
      <span class="iconfont">&#xe70b;</span>行业企业信息
      <span class="iconfont">&#xe70b;</span>危货企业
    </div>
    <div style="padding:0 200px;margin:10px 0 20px 0;">
      <el-input placeholder="请输入内容" v-model="input">
        <el-select v-model="select" slot="prepend" placeholder="请选择">
          <el-option label="企业名称" value="1"></el-option>
          <el-option label="所属旗区" value="2"></el-option>
        </el-select>

        <el-button slot="append" icon="el-icon-search" @click="getTaxiData"></el-button>
      </el-input>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="name" label="企业名称" width="300px"></el-table-column>
      <el-table-column prop="legal" label="单位负责人" width></el-table-column>
      <el-table-column prop="certificate_num" label="经营许可证编号" width></el-table-column>
      <el-table-column prop="transport_num" label="道路许可证编号" width></el-table-column>
      <el-table-column prop="c_qsdm" label="所属旗区" width></el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="sumnum"
      :current-page='currentPage'
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
import { ipconfig } from "@/assets/js/ipconfig.js";
import Axios from "axios";
export default {
  name: "taxiTraffic",
  data() {
    return {
      currentPage:1,
      val: "",
      input: "",
      select: "",
      tableData: [],
      sumnum: 0,
      con_unitType:3,//1为出租 2为客运 3为危货 4为普货
    };
  },
  watch: {
    select: function(data) {
      this.val = data;
    }
  },
  created() {
    this.getInitTaxiData();
  },
  methods: {
    getInitTaxiData() {
      let param = new URLSearchParams();
      param.append("con_PageNumber", this.currentPage);
      param.append("con_PageSize", 10);
      param.append("con_unitType", this.con_unitType);
      Axios.post(
        `http://${ipconfig}/app/isweb/industry/getUnits?innerMS`,
        param
      ).then(data => {
        if (data.status === 200) {
          this.sumnum = data.data.data.sumnum;
          this.tableData = data.data.data.industryUnits;
        }
      });
    },

    getTaxiData() {
      let param = new URLSearchParams();
      param.append("con_PageNumber", 1);
      param.append("con_PageSize", 10);
      param.append("con_unitType", this.con_unitType);
      if (this.input) {
        if (this.val == "1") {
          param.append("name", this.input);
        } else if (this.val == "2") {
          param.append("c_qsdm", this.input);
        } else {
          alert("请选择搜索类型")
          return;
        }
      }else{
        alert("请输入搜索关键词")
      }
      Axios.post(
        `http://${ipconfig}/app/isweb/industry/getUnits?innerMS`,
        param
      ).then(data => {
        if (data.status === 200) {
          this.currentPage = 1;
          this.sumnum = data.data.data.sumnum;
          this.tableData = data.data.data.industryUnits;
        }
      });
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      let param = new URLSearchParams();
      param.append("con_PageNumber", val);
      param.append("con_PageSize", 10);
      param.append("con_unitType", this.con_unitType);
      if (this.input) {
        if (this.val == "1") {
          param.append("name", this.input);
        } else if (this.val == "1") {
          param.append("c_qsdm", this.input);
        } else {
          return;
        }
      }
      Axios.post(
        `http://${ipconfig}/app/isweb/industry/getUnits?innerMS`,
        param
      ).then(data => {
        if (data.status === 200) {
          this.sumnum = data.data.data.sumnum;
          this.tableData = data.data.data.industryUnits;
        }
      });
    }
  }
};
</script>
<style scoped>
.taxiContainner {
  height: 100%;
  position: relative;
}
.el-pagination {
  text-align: center;
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  margin: 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/hyjdmsg/dangerTraffic.vue